import { makeStyles } from '@material-ui/styles';
import { IconButton, MinusSign, PersonAvatar, Text } from '@bizzabo/design-system';
import { useState } from 'react';
import DeclineButton from '../DeclineButton';
import JoinButton from '../JoinButton';
import { UserPreview, UserData } from '@bizzabo/entities';

export interface VideoLargeNotificationProps {
    currentUser: UserData;
    callerUser: UserPreview;
    minimizeHandle: () => void;
}

const VideoLargeNotification: React.FC<VideoLargeNotificationProps> = ({
    currentUser,
    callerUser,
    minimizeHandle,
}) => {
    const classes = useStyles();
    const [imgError, setImgError] = useState(false);

    return (
        <>
            <IconButton
                icon={MinusSign}
                className={classes.minimizeButton}
                onClick={minimizeHandle}
                aria-label={'minimize-button'}
            />
            <div className={classes.content}>
                <div className={classes.pictureWrapper}>
                    {imgError || !callerUser?.photoUrl ? (
                        <PersonAvatar />
                    ) : (
                        <img
                            src={callerUser?.photoUrl}
                            className={classes.picture}
                            alt="User Image"
                            onError={() => setImgError(true)}
                        />
                    )}
                </div>
                <div className={classes.interaction}>
                    <div className={classes.textsWrapper}>
                        <Text variant="t40" className={classes.text}>
                            {`${callerUser?.firstName} ${callerUser?.lastName}`}
                        </Text>
                        <Text variant="t50" className={`${classes.subTitle} ${classes.text}`}>
                            Invites you to join a meeting
                        </Text>
                    </div>
                    <div className={classes.buttons}>
                        <DeclineButton />
                        <JoinButton currentUser={currentUser} />
                    </div>
                </div>
            </div>
        </>
    );
};

const useStyles = makeStyles(
    theme => ({
        content: {
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            color: theme.palette.greys[100],
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '36px',
            boxShadow: '0px 4px 24px 0px #0000001A',
        },
        pictureWrapper: {
            height: '55%',
            backgroundColor: theme.palette.greys[300],
            borderRadius: '36px 36px 0 0',
        },
        picture: {
            width: '100%',
            borderRadius: '36px 36px 0 0',
            objectFit: 'fill',
        },
        interaction: {
            height: '45%',
            backgroundColor: theme.palette.greys[800],
            borderRadius: '0 0 36px 36px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '40px 16px',
        },
        textsWrapper: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            marginBottom: 8,
        },
        text: {
            whiteSpace: 'nowrap',
        },
        subTitle: {
            marginTop: 8,
        },
        buttons: {
            display: 'flex',
            justifyContent: 'space-between',
        },
        minimizeButton: {
            width: 24,
            height: 24,
            position: 'absolute',
            top: 16,
            left: 16,
            zIndex: 2,
            cursor: 'pointer',
            backgroundColor: theme.palette.greys[100],
            mixBlendMode: 'unset',
        },
    }),
    { classNamePrefix: 'video-notifications-video-lg-notification' }
);

export default VideoLargeNotification;
